import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { cmsCall } from "@/lib/cms";

const cache = new Map(); // nl-naam -> {nl,en,de,fr}

/**
 * Vertaalde labels voor CRM-categorienamen. De vertaling gebeurt eenmalig in de
 * backend (AI) en wordt daar bewaard; hier alleen ophalen en teruggeven.
 */
export function useCategoryLabels(namen) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const [, forceUpdate] = useState(0);
  const sleutel = (namen || []).filter(Boolean).join("|");

  useEffect(() => {
    const ontbreekt = (namen || []).filter((n) => n && !cache.has(n));
    if (ontbreekt.length === 0) return;
    cmsCall("POST", "/content/categorieen/vertaal", { namen: ontbreekt })
      .then((res) => {
        Object.entries(res?.vertalingen || {}).forEach(([naam, vertaling]) => cache.set(naam, vertaling));
        ontbreekt.forEach((naam) => cache.has(naam) || cache.set(naam, { nl: naam }));
        forceUpdate((n) => n + 1);
      })
      .catch(() => {
        ontbreekt.forEach((naam) => cache.set(naam, { nl: naam }));
        forceUpdate((n) => n + 1);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sleutel]);

  return (naam) => {
    if (!naam) return naam;
    const vertaling = cache.get(naam);
    return (vertaling && (vertaling[lang] || vertaling.nl)) || naam;
  };
}
